// How players pay, and the first pass a venue's setup offers (ADR-0058; spec/13 §13.1, spec/06 §3–§5).
//
// A venue's players pay for play time in three ways: a **pass** (a block of time bought ahead, the venue's default), **pay
// as you go** (an hourly rate per station class, charged as they play; off for a venue created since 2026-10-12) and the
// **wallet** (a balance topped up at the counter, which pays for play only when `sessions.walletFundsPlay` is on). The
// setup step "How players pay" explains the three and makes the first pass, prefilled from what is here: an hour of play,
// on every class, sold at the counter and on the PCs, priced at what an hour costs at the venue now.
//
// Nothing here reads a clock or a database: the console hands in the rates it read, and money stays integer minor units
// of the venue's currency.
/** The starter pass's play time: an hour. */
export const STARTER_PASS_MINUTES = 60;
/** How long a holding of it stays valid after it is bought: the pass editor's own default. */
export const STARTER_PASS_VALIDITY_DAYS = 30;
/** Where it is sold: at the counter and on the kiosk at the PC (the pass editor's default). */
export const STARTER_PASS_CHANNELS = ['counter', 'kiosk'];
/**
 * What an hour costs when nothing at the venue says: the registry's pay-as-you-go rate (`sessions.paygHourlyRate`,
 * 6000 minor units, ₹60.00 in rupees) — the same figure as the demo venue's "1 hour" pass.
 */
export const STARTER_HOURLY_FALLBACK_MINOR = 6000;
const usable = (amount) => Number.isSafeInteger(amount) && amount > 0;
/**
 * The price the starter pass is prefilled with, in minor units: an hour on the venue's cheapest class (so an hour bought
 * ahead never costs more than the same hour played as you go, on any class), else the flat rate, else the registry's
 * ₹60.00. The owner edits it before the pass is made; zero is never offered, because a free pass is a staff grant and
 * not on sale.
 */
export function starterPassPrice(input) {
    const rates = input.classHourlyRates.filter(usable);
    if (rates.length > 0)
        return Math.min(...rates);
    return usable(input.flatHourlyRate) ? input.flatHourlyRate : STARTER_HOURLY_FALLBACK_MINOR;
}
//# sourceMappingURL=starter-pass.js.map